const { Component } = Shopware;

Component.extend('acris-one-to-many-faq-grid', 'sw-one-to-many-grid', {

    methods: {
        createdComponent() {
            this.$super('createdComponent');
        },

        applyResult(result) {
            this.$super('applyResult', result);
        },

        load() {
            return this.repository.search(this.result.criteria, this.result.context)
                .then(this.applyResult);
        },

    },
});
